/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import qs from "qs";

import Select from "assets/svg/select";
import Selected from "assets/svg/selected";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputBase from "@mui/material/InputBase";
import PlaceholderPhoto from "assets/img/placeholderPhoto.png";

import useStyles from "./style";
import Button from "components/button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Flex, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

const Input = styled(InputBase)(({ theme }) => ({
  "label + &": { marginTop: theme.spacing(3) },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

const EditProfile = () => {
  const location = useLocation();
  const styles = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [lastUser, setLastUser] = useState({});
  const [user, setUser] = useState({});
  const [avatars, setAvatars] = useState([]);
  const [selectedAvatar, setSelectedAvatar] = useState();
  const [refetch, setRefetch] = useState(0);
  const [file, setFile] = useState();
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [token, setToken] = useState("");
  const [isOnboarding, setIsOnboarding] = useState(false);
  const [openDeleteAcc, setOpenDeleteAcc] = useState(false);

  ///user/delete-account
  // baca query param dengan aman
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setIsOnboarding(params.get("isOnboarding") === "true");
  }, [location.search]);

  // fetch user
  useEffect(() => {
    const tmpToken = localStorage.getItem("token");
    setToken(tmpToken || "");
    if (!tmpToken) return;

    axios
      .get("https://api.personatalenta.id/user/current", {
        headers: { Authorization: `Bearer ${tmpToken}` },
      })
      .then((res) => {
        setUser(res.data.user || {});
        setLastUser(res.data.user || {});
      })
      .catch((err) => {
        if (err?.response?.data?.message === "Unauthorized") {
          // navigate('/');
        }
      });
  }, [refetch]);

  // fetch resources (avatar list)
  useEffect(() => {
    if (!token) return;
    axios
      .get("https://api.personatalenta.id/user/registration_data", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setAvatars(res?.data?.data?.avatars || []);
      })
      .catch((err) => {
        if (err?.response?.data?.message === "Unauthorized") {
          // navigate('/');
        }
      });
  }, [token]);

  // validasi field wajib saat onboarding
  const isProfileValid = useMemo(() => {
    const required = ["name", "birth_date", "birth_time"];
    const filled = required.every((k) => !!user?.[k]);
    const genderOk =
      user?.gender === 0 ||
      user?.gender === 1 ||
      user?.gender === "0" ||
      user?.gender === "1";
    return filled && genderOk;
  }, [user]);

  const ensureValidOrShowError = () => {
    setError("");
    const newErrors = {};
    let isValid = true;

    if (isOnboarding) {
      if (!user.name) {
        newErrors.name = "Display Name wajib diisi";
        isValid = false;
      }
      if (!user.birth_date) {
        newErrors.birth_date = "Tanggal Lahir wajib diisi";
        isValid = false;
      }
      if (!user.birth_time) {
        newErrors.birth_time = "Jam Lahir wajib diisi";
        isValid = false;
      }
      if (
        user.gender !== 0 &&
        user.gender !== 1 &&
        user.gender !== "0" &&
        user.gender !== "1"
      ) {
        newErrors.gender = "Gender wajib dipilih";
        isValid = false;
      }
    }

    if (user.birth_date) {
      const birthDate = new Date(user.birth_date);
      const minDate = new Date("1940-01-01");
      const maxDate = new Date("2040-12-31");
      if (birthDate < minDate || birthDate > maxDate) {
        newErrors.birth_date = "Tanggal lahir tidak valid (1940-2040)";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!ensureValidOrShowError()) return;

    try {
      // kirim data
      await axios.post(
        "https://api.personatalenta.id/user/edit",
        qs.stringify({ ...user }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // ==> ambil user terbaru dari server (lebih aman daripada asumsi)
      const res = await axios.get(
        "https://api.personatalenta.id/user/current",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const freshUser = res.data.user || res.data || user;

      // simpan ke localStorage supaya komponen lain dapat membaca
      localStorage.setItem("user", JSON.stringify(freshUser));

      // beri sinyal ke halaman lain bahwa user update
      window.dispatchEvent(
        new CustomEvent("userUpdated", { detail: { user: freshUser } })
      );

      // jika onboarding: pindah ke home, else kembali ke profile tanpa reload
      if (isOnboarding) {
        window.location.assign("/");
      } else {
        // jika kamu ingin tetap di halaman profile tapi tanpa reload:
        window.location.assign("/dashboard/profile");
      }
    } catch (err) {
      // Handle general error if needed, or map to specific fields if API returns field errors
      setError(
        err?.response?.data?.message ||
          err?.response?.data ||
          "Terjadi kesalahan."
      );
    }
  };

  const onChangeInput = (e) => {
    const { id, value } = e.target;
    if (!id) return;

    if (id === "password") {
      setUser((u) => ({ ...u, password1: value, password2: value }));
    } else if (id === "gender") {
      setUser((u) => ({ ...u, gender: Number(value) })); // simpan sebagai number
    } else {
      setUser((u) => ({ ...u, [id]: value }));
    }
  };

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleClickOpenConfirm = () => {
    if (!ensureValidOrShowError()) return;
    if (lastUser.birth_date !== user.birth_date) {
      setOpenConfirm(true);
    } else {
      handleSubmit();
    }
  };
  const handleCloseConfirm = () => setOpenConfirm(false);

  const handleSelectAvatar = (avatar) => {
    setUser((u) => ({ ...u, avatar: avatar.name }));
    setSelectedAvatar(avatar);
  };

  const handleSaveAvatar = () => {
    if (!selectedAvatar) return;
    axios
      .post(
        "https://api.personatalenta.id/user/photo",
        qs.stringify({ avatar: selectedAvatar.name }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => window.location.reload())
      .catch((err) =>
        setError(err?.response?.data?.message || err?.response?.data)
      );
  };

  const handleChangePhoto = (event) => {
    setFile(event.target.files?.[0]);
    event.preventDefault();

    const url = "https://api.personatalenta.id/user/photo";
    const formData = new FormData();
    if (event.target.files?.[0])
      formData.append("photo", event.target.files[0]);

    axios
      .post(url, formData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => window.location.reload())
      .catch((err) =>
        setError(err?.response?.data?.message || err?.response?.data)
      );
  };

  const handleDeleteAccount = () => {
    const token = localStorage.getItem("token");
    axios
      .delete(`https://api.personatalenta.id/user/delete-account`, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
      })
      .then((res) => {
        localStorage.clear();
        window.location.assign("/");
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err?.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  };

  const onCloseDelete = () => {
    setOpenDeleteAcc(false);
  };

  const todayLocalISO = new Date(
    Date.now() - new Date().getTimezoneOffset() * 60000
  )
    .toISOString()
    .split("T")[0];

  return (
    <div className={styles.app}>
      <div className={styles.services}>
        <div className={styles.servicesContainer}>
          <div className={styles.containerContent}>
            <div className={styles.rightContainer}>
              <div className={styles.containerSectionServices}>
                {error && <span className={styles.error}>{error}</span>}

                {isOnboarding && (
                  <div className={styles.onboarding}>
                    <p className={styles.onboardingText}>Registrasi Berhasil</p>
                    <p className={styles.onboardingText}>
                      Pastikan profilmu lengkap dan benar untuk layanan Persona
                      Talenta yang lebih akurat.
                    </p>
                  </div>
                )}

                <div className={styles.containerForm}>
                  <FormControl
                    variant="standard"
                    className={styles.formControlPhoto}
                  >
                    <div className={styles.containerQuestion}>
                      <div>
                        {user.photo ? (
                          <img
                            src={
                              selectedAvatar ? selectedAvatar.url : user.photo
                            }
                            alt="Profile"
                            width={157}
                            className={styles.placeholderPhoto}
                          />
                        ) : (
                          <img
                            src={PlaceholderPhoto}
                            alt="placeholder"
                            width={157}
                            className={styles.placeholderPhoto}
                          />
                        )}
                        <p className={styles.infoFile}>
                          Maximum file size of 1 MB
                        </p>
                      </div>
                      <div style={{ marginTop: 5 }}>
                        <Input
                          fullWidth
                          id="file"
                          style={{ display: "none" }}
                          className={styles.inputFile}
                          type="file"
                          onChange={handleChangePhoto}
                        />
                        <label
                          shrink="true"
                          htmlFor="file"
                          className={styles.labelBrowse}
                        >
                          Browse Gallery
                        </label>
                        <div
                          className={styles.buttonUpload}
                          onClick={handleClickOpen}
                        >
                          <span>Browse Avatar</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      {!isMobile && (
                        <Button
                          variant="tertiary"
                          style={{
                            width: 130,
                            paddingLeft: 10,
                            paddingRight: 10,
                            borderWidth: 0.75,
                            borderColor: "gray",
                            color: "gray",
                            fontSize: 11,
                          }}
                          label={"Delete Account"}
                          onClick={() => setOpenDeleteAcc(true)}
                        />
                      )}
                    </div>
                  </FormControl>

                  <div className={styles.containerEditProfile}>
                    <div className="add-friend">
                      <h6 className="label">Display Name</h6>
                      <FormControl
                        variant="standard"
                        className={styles.formControl}
                      >
                        <Input
                          fullWidth
                          id="name"
                          value={user.name || ""}
                          className={styles.input}
                          onChange={onChangeInput}
                          type="text"
                          inputProps={{ maxLength: 20 }}
                          placeholder="Display Name"
                        />
                        <p className={styles.infoRequired}>
                          Dapat diubah setiap 3 ( tiga ) bulan sekali
                        </p>
                        {errors.name && (
                          <p
                            style={{ color: "red", fontSize: 12, marginTop: 5 }}
                          >
                            {errors.name}
                          </p>
                        )}
                      </FormControl>
                    </div>

                    <div className="add-friend">
                      <h6 className="label">Occupation</h6>
                      <FormControl
                        variant="standard"
                        className={styles.formControl}
                      >
                        <Input
                          fullWidth
                          id="occupation"
                          value={user.occupation || ""}
                          onChange={onChangeInput}
                          className={styles.input}
                          type="text"
                          placeholder="Occupation"
                        />
                      </FormControl>
                    </div>

                    <div className="add-friend">
                      <h6 className="label">Tanggal Lahir</h6>
                      <FormControl
                        variant="standard"
                        className={styles.formControl}
                      >
                        <Input
                          fullWidth
                          id="birth_date"
                          value={user.birth_date || ""}
                          onChange={onChangeInput}
                          className={styles.input}
                          type="date"
                          placeholder="Tanggal Lahir"
                          inputProps={{ min: "1900-01-01", max: todayLocalISO }}
                        />
                        {errors.birth_date && (
                          <p
                            style={{ color: "red", fontSize: 12, marginTop: 5 }}
                          >
                            {errors.birth_date}
                          </p>
                        )}
                      </FormControl>
                    </div>

                    <div className="add-friend">
                      <h6 className="label">Jam Lahir</h6>
                      <FormControl
                        variant="standard"
                        className={styles.formControl}
                      >
                        <Input
                          fullWidth
                          id="birth_time"
                          value={user.birth_time || ""}
                          onChange={onChangeInput}
                          className={styles.input}
                          type="time"
                          placeholder="Jam Lahir"
                        />
                        {errors.birth_time && (
                          <p
                            style={{ color: "red", fontSize: 12, marginTop: 5 }}
                          >
                            {errors.birth_time}
                          </p>
                        )}
                      </FormControl>
                    </div>

                    <div className="add-friend">
                      <h6 className="label">Tempat Lahir</h6>
                      <FormControl
                        variant="standard"
                        className={styles.formControl}
                      >
                        <Input
                          fullWidth
                          id="birth_location"
                          value={user.birth_location || ""}
                          onChange={onChangeInput}
                          className={styles.input}
                          type="text"
                          placeholder="Tempat Lahir"
                        />
                      </FormControl>
                    </div>

                    <div className="add-friend">
                      <h6 className="label">Gender</h6>
                      <FormControl
                        variant="gender"
                        className={styles.formControlSmall}
                      >
                        <RadioGroup
                          row
                          id="gender"
                          value={user.gender ?? ""}
                          onChange={onChangeInput}
                        >
                          <FormControlLabel
                            value={0}
                            control={
                              <Radio
                                id="gender"
                                icon={<Select />}
                                checkedIcon={<Selected />}
                              />
                            }
                            label="Pria"
                          />
                          <FormControlLabel
                            value={1}
                            control={
                              <Radio
                                id="gender"
                                icon={<Select />}
                                checkedIcon={<Selected />}
                              />
                            }
                            label="Wanita"
                          />
                        </RadioGroup>
                        {errors.gender && (
                          <p
                            style={{ color: "red", fontSize: 12, marginTop: 5 }}
                          >
                            {errors.gender}
                          </p>
                        )}
                      </FormControl>
                    </div>

                    <div className={styles.containerButton}>
                      {/* Sembunyikan tombol Cancel ketika onboarding */}
                      {!isOnboarding && (
                        <Button
                          variant="alternate"
                          label="Cancel"
                          onClick={() =>
                            window.location.assign("/dashboard/profile")
                          }
                        />
                      )}
                      <Button
                        variant="primary"
                        label={isOnboarding ? "Submit" : "Save"}
                        onClick={handleClickOpenConfirm}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isMobile && (
                <div
                  className={styles.containerButton}
                  style={{ justifyContent: "start" }}
                >
                  <Button
                    variant="tertiary"
                    style={{
                      paddingLeft: 10,
                      paddingRight: 10,
                      borderWidth: 0.75,
                      borderColor: "gray",
                      color: "gray",
                      fontSize: 11,
                    }}
                    label={"Delete Account"}
                    onClick={() => setOpenDeleteAcc(true)}
                  />
                </div>
              )}

              {/* Dialog Pilih Avatar */}
              <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
              >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                  Select Avatar
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                  <Flex
                    flexDirection="row"
                    wrap="wrap"
                    maxWidth="100%"
                    gap={8}
                    alignItems="center"
                    justifyContent="center"
                  >
                    {avatars.map((avatar) => (
                      <Flex
                        key={avatar.name}
                        borderWidth={user.avatar === avatar.name ? 5 : 0}
                        borderRadius={500}
                        borderColor="#E24E06"
                        cursor="pointer"
                        onClick={() => handleSelectAvatar(avatar)}
                      >
                        <Avatar
                          mx="auto"
                          src={avatar.url}
                          h="130px"
                          w="130px"
                        />
                      </Flex>
                    ))}
                  </Flex>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="primary"
                    label="Select"
                    onClick={handleSaveAvatar}
                  />
                </DialogActions>
              </BootstrapDialog>

              {/* Dialog konfirmasi ubah tanggal lahir */}
              <BootstrapDialog
                onClose={handleCloseConfirm}
                aria-labelledby="customized-dialog-title"
                open={openConfirm}
              >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                  Apakah kamu yakin?
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleCloseConfirm}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                  <Flex
                    flexDirection="row"
                    wrap="wrap"
                    maxWidth="100%"
                    gap={8}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text>
                      Apakah Kamu yakin akan mengganti Tanggal Lahir? Aplikasi
                      akan mengidentifikasi Kamu sebagai pengguna baru lagi
                      dalam layanannya.
                    </Text>
                  </Flex>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="alternate"
                    label="Cancel"
                    onClick={handleCloseConfirm}
                  />
                  <Button
                    variant="primary"
                    label="Save"
                    onClick={handleSubmit}
                  />
                </DialogActions>
              </BootstrapDialog>
              <BootstrapDialog
                onClose={onCloseDelete}
                aria-labelledby="customized-dialog-title"
                open={openDeleteAcc}
              >
                <DialogTitle
                  sx={{ m: 0, p: 3, backgroundColor: "#D5DDFC" }}
                  id="customized-dialog-title"
                ></DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={onCloseDelete}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon width={3} />
                </IconButton>
                <DialogContent>
                  <Flex
                    flexDirection="column"
                    wrap="wrap"
                    maxWidth="100%"
                    gap={1}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text>Apakah kamu akan menghapus User ini?</Text>
                  </Flex>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                  <Button
                    variant="primary"
                    label="Ya"
                    style={{
                      padding: "5px 10px",
                      backgroundColor: "red",
                      color: "white",
                    }}
                    onClick={handleDeleteAccount}
                  />
                </DialogActions>
              </BootstrapDialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
